/* Aden Salt Company — header behaviour. Ported from the original section-scripts-a.js outer IIFE:
   the sticky header CTA and the transparent-over-hero -> light chrome crossfade, unchanged. The
   original kept these in one closure with the other "Get my price" buttons (now 00-utils.js), so
   the small openHeroForm dispatcher is repeated here verbatim — it only fires the hvc:open event
   the hero script listens for. */
(function(){
  "use strict";
  function openHeroForm(salt){
    var ev;
    try{ ev = new CustomEvent('hvc:open', {detail:{salt:salt || ''}}); }
    catch(err){ ev = document.createEvent('CustomEvent'); ev.initCustomEvent('hvc:open', false, false, {salt:salt || ''}); }
    document.dispatchEvent(ev);
  }
  /* ---------- Sticky header CTA: shows once the hero form is off screen ---------- */
  var stickyCta = document.getElementById('stickyCta');
  var heroFormWrap = document.getElementById('heroFormWrap');
  if(stickyCta && heroFormWrap && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          stickyCta.classList.remove('show');
          stickyCta.classList.add('hide');
        }else{
          stickyCta.classList.remove('hide');
          stickyCta.classList.add('show');
        }
      });
    }, {threshold:0});
    io.observe(heroFormWrap);
    stickyCta.addEventListener('click', function(e){ e.preventDefault(); openHeroForm(''); });
  }
  /* ---------- Header transparent-over-hero -> light chrome crossfade ---------- */
  var heroScene = document.querySelector('.hv-c');
  var topbarEl = document.querySelector('.topbar');
  if(heroScene && topbarEl){
    var heroThreshold = 0;
    var computeHeroThreshold = function(){
      var rect = heroScene.getBoundingClientRect();
      heroThreshold = rect.top + window.scrollY + heroScene.offsetHeight * 0.7;
    };
    /* Is the band sitting under the header a dark (navy) ground? */
    var overDarkBand = function(){
      var h = topbarEl.offsetHeight;
      var x = window.innerWidth / 2;
      var y = Math.max(1, Math.round(h / 2));
      var under = null;
      if(document.elementsFromPoint){
        var stack = document.elementsFromPoint(x, y);
        for(var i = 0; i < stack.length; i++){
          if(!topbarEl.contains(stack[i])){ under = stack[i]; break; }
        }
      }else{
        under = document.elementFromPoint(x, h + 1);
      }
      return !!(under && under.closest && under.closest('[data-tone="dark"]'));
    };
    var updateHeaderState = function(){
      if(window.scrollY > heroThreshold){
        var dark = overDarkBand();
        topbarEl.classList.toggle('scrolled', !dark);
        topbarEl.classList.toggle('frosted-dark', dark);
      }else if(window.scrollY > 10){
        topbarEl.classList.remove('scrolled');
        topbarEl.classList.add('frosted-dark');
      }else{
        topbarEl.classList.remove('scrolled');
        topbarEl.classList.remove('frosted-dark');
      }
    };
    computeHeroThreshold();
    updateHeaderState();
    window.addEventListener('resize', function(){ computeHeroThreshold(); updateHeaderState(); });
    var headerTicking = false;
    window.addEventListener('scroll', function(){
      if(headerTicking) return;
      headerTicking = true;
      requestAnimationFrame(function(){ updateHeaderState(); headerTicking = false; });
    }, {passive:true});
  }
})();
